<!-- src/components/kb_workspace/deploy.vue -->
<template>
  <div>
    <el-row :gutter="10" class="mb16">
      <a>您的AI客服中心分为主工作区（当前环境，用于内部维护和管理）、蓝环境（当前线上服务使用的知识库）、绿环境（空闲，用于下一版本发布）发布AI客服中心的流程如下：</a>
    </el-row>
    <el-row :gutter="10" class="mb16">
     
    </el-row>
    <div class="deploy-steps-container">
      <a :class="deploy_step_status1">{{ deploy_step_text1 }}</a>
      <a :class="deploy_step_status2">{{ deploy_step_text2 }}</a>
      <a :class="deploy_step_status3">{{ deploy_step_text3 }}</a>
      <a :class="deploy_step_status4">{{ deploy_step_text4 }}</a>
    </div>
    
    <!-- 发布中状态提示 -->
    <div v-if="deploying" class="deploying-tip">
      <i class="el-icon-loading"></i>
      <span>正在派发发布任务，请稍候...</span>
    </div>
  </div>
</template>

<script>
import { getKbWorkspaceDetails, listKbWorkspaces_by_tenantId, createKbWorkspace } from '@/api/aics/kbWorkspace';
import { publishDeployTask } from '@/api/aics/deploy';
import { getDocumentStatic_by_tenant } from '@/api/aics/KbDocument';
import { formatDatefromTimestamp,formatToBeijingTime } from '@/util/date';

export default {
  name: "KbWorkspaceDeploy",
  props: {
    slug: {
      type: String,
      default: ''
    }
  },
  data() {
    return {

      deploy_step_text1: '1. 验证主工作区文档数量',
      deploy_step_text2: '2. 验证蓝环境',
      deploy_step_text3: '3. 验证绿环境',
      deploy_step_text4: '4. 派发异步发布任务',
      deploy_step_status1: 'deploy_step',
      deploy_step_status2: 'deploy_step',
      deploy_step_status3: 'deploy_step',
      deploy_step_status4: 'deploy_step',
      workspace_blue: '',
      workspace_green: '',
      workspace_master: null,
      deploying: false,  // 防重复点击
      form: {
        name: '',
        lastUpdatedAt: '',
        openAiTemp: '',
      },
      createWorkspaceForm: {
        name: '',
        serviceTo: '',
        masterSlug: '',
      },
      publishRequestForm: {
        tenantId: 0,
        mainWorkspaceSlug: '',
        blueWorkspaceSlug: '',
        greenWorkspaceSlug: '',
        docCount: 0
      }
    }
  },
  computed: {
    tenantInfo() {
      return this.$store.getters['auth/currentTenant'];
    },
    tenantId() {
      return this.tenantInfo?.tenantId || null;
    }
  },
  mounted() {
    getKbWorkspaceDetails(this.slug).then(res => {
      console.log("getKbWorkspaceDetails - 响应:", res.data);
      if (res.data && res.data.workspace && res.data.workspace.length > 0) {
        this.form.name = res.data.workspace[0].name;
        this.form.lastUpdatedAt = formatDatefromTimestamp(res.data.workspace[0].lastUpdatedAt);
        this.form.openAiTemp = res.data.workspace[0].openAiTemp;
      }
    });
  },
  methods: {
    formatToBeijingTime(value){
      return formatToBeijingTime(value)
    },      
    submitForm() {
      console.log("this.form:", this.form);
      // 配置表单提交逻辑...
    },
    
    async deploy() {

      // 防重复点击
      if (this.deploying) {
        this.$message.warning('正在处理中，请勿重复点击');
        return;
      }
      
      this.deploying = true;
      
      try {
        // 重置步骤状态
        this.resetSteps();
        
        // 步骤1：验证主工作区文档数量
        this.deploy_step_status1 = "deploy_step_active";
        let res = await getDocumentStatic_by_tenant(this.tenantId, '');
        console.log("getDocumentStatic_by_tenant - 响应:", res);
        
        if (res == null || res.code != 200) {
          this.deploy_step_status1 = "deploy_step_error";
          this.deploy_step_text1 = "验证主工作区文档数量失败：无法获取主工作区中的文档信息";
          return;
        }
        
        let docCount = Number(res.data.doc_count);
        if (docCount <= 0) {
          this.deploy_step_status1 = "deploy_step_error";
          this.deploy_step_text1 = "验证主工作区文档数量失败：主工作区中没有文档";
          return;
        } else {
          this.deploy_step_status1 = "deploy_step_success";
          this.deploy_step_text1 = "验证主工作区文档数量成功：主工作区中有" + docCount + "个文档";
        }

        // 步骤2：获取蓝绿库
        this.deploy_step_status2 = "deploy_step_active";
        res = await listKbWorkspaces_by_tenantId(this.tenantId);
        console.info("listKbWorkspaces_by_tenantId", res);
        
        let workspaces = res.data;
        if (!workspaces) {
          this.deploy_step_status2 = "deploy_step_error";
          this.deploy_step_text2 = "验证绿环境失败：无法获取工作区列表";
          return;
        }
        
        // 查找主工作区、蓝环境、绿环境
        for (let i = 0; i < workspaces.length; i++) {
          if ((workspaces[i].category == 0 || workspaces[i].category == null) && 
              (workspaces[i].parentId == 0 || workspaces[i].parentId == null)) {
            this.workspace_master = workspaces[i];
          }
          if (workspaces[i].category == 1 && workspaces[i].parentId != 0) {
            this.workspace_blue = workspaces[i];
          }
          if (workspaces[i].category == 2 && workspaces[i].parentId != 0) {
            this.workspace_green = workspaces[i];
          }
        }
        
        console.info("主工作区：", this.workspace_master);
        console.info("蓝环境：", this.workspace_blue);
        console.info("绿环境：", this.workspace_green);
        
        // 创建蓝环境（如果不存在）
        if (!this.workspace_blue) {
          this.deploy_step_text2 = "验证蓝环境：正在创建...";
          this.createWorkspaceForm = {
            name: this.workspace_master.name + " - 生产环境-1",
            serviceTo: this.workspace_master.serviceTo,
            masterSlug: this.workspace_master.slug,
          };
          let createRes = await createKbWorkspace(this.tenantId, this.createWorkspaceForm);
          console.log("创建蓝环境结果：", createRes);
          if (createRes.code == 200) {
            this.deploy_step_status2 = "deploy_step_success";
            this.deploy_step_text2 = "验证蓝环境成功：已新建蓝环境";
            // 刷新蓝环境信息
            const refreshRes = await listKbWorkspaces_by_tenantId(this.tenantId);
            const refreshedWorkspaces = refreshRes.data;
            console.log("listKbWorkspaces_by_tenantId", refreshedWorkspaces)
            for (let i = 0; i < refreshedWorkspaces.length; i++) {
              if (refreshedWorkspaces[i].category == 1 && refreshedWorkspaces[i].parent_id != 0) {
                this.workspace_blue = refreshedWorkspaces[i];
              }
            }
          } else {
            this.deploy_step_status2 = "deploy_step_error";
            this.deploy_step_text2 = "验证蓝环境失败：" + (createRes.message || "创建失败");
            return;
          }
        } else {
          this.deploy_step_status2 = "deploy_step_success";
          this.deploy_step_text2 = "验证蓝环境成功：蓝环境已准备就绪";
        }
        
        // 创建绿环境（如果不存在）
        this.deploy_step_status3 = "deploy_step_active";
        if (!this.workspace_green) {
          this.deploy_step_text3 = "验证绿环境：正在创建...";
          this.createWorkspaceForm = {
            name: this.workspace_master.name + " - 生产环境-2",
            serviceTo: this.workspace_master.serviceTo,
            masterSlug: this.workspace_master.slug,
          };
          let createRes = await createKbWorkspace(this.tenantId, this.createWorkspaceForm);
          if (createRes.code == 200) {
            this.deploy_step_status3 = "deploy_step_success";
            this.deploy_step_text3 = "验证绿环境成功：已新建绿环境";
            // 刷新绿环境信息
            const refreshRes = await listKbWorkspaces_by_tenantId(this.tenantId);
            const refreshedWorkspaces = refreshRes.data;
            for (let i = 0; i < refreshedWorkspaces.length; i++) {
              if (refreshedWorkspaces[i].category == 2 && refreshedWorkspaces[i].parentId != 0) {
                this.workspace_green = refreshedWorkspaces[i];
              }
            }
          } else {
            this.deploy_step_status3 = "deploy_step_error";
            this.deploy_step_text3 = "验证绿环境失败：" + (createRes.message || "创建失败");
            return;
          }
        } else {
          this.deploy_step_status3 = "deploy_step_success";
          this.deploy_step_text3 = "验证绿环境成功：绿环境已准备就绪";
        }
        
        // 步骤4：派发异步发布任务
        this.deploy_step_status4 = "deploy_step_active";
        this.deploy_step_text4 = "派发异步发布任务...";
        
        this.publishRequestForm = {
          tenantId: this.tenantId,
          mainWorkspaceSlug: this.workspace_master.slug,
          blueWorkspaceSlug: this.workspace_blue.slug,
          greenWorkspaceSlug: this.workspace_green.slug,
          docCount: docCount
        };
        
        console.info("publishRequestForm", this.publishRequestForm);
        
        const publishRes = await publishDeployTask(this.publishRequestForm);
        console.log("publishDeployTask", publishRes);
        
        if (publishRes.code == 200) {
          this.deploy_step_status4 = "deploy_step_success";
          
          const taskId = publishRes.message;
          if (taskId) {
            this.deploy_step_text4 = "异步发布任务已派发，请前往任务中心查看进度";
            this.$message.success(`发布任务已派发，任务ID: ${taskId}`);
            
            // 询问用户是否前往任务中心
            this.$confirm(
              `发布任务已派发成功！任务ID: ${taskId}，是否立即前往任务中心查看进度？`,
              '任务已派发',
              {
                confirmButtonText: '前往任务中心',
                cancelButtonText: '稍后查看',
                type: 'success'
              }
            ).then(() => {
              // 通知父组件打开任务中心
              this.$emit('open-task-center', taskId);
              this.$emit('submit-success', true);
            }).catch(() => {
              this.$message.info('可在知识库管理页面右上角【发布任务】按钮查看进度');
              this.$emit('submit-success', true);
            });
          } else {
            this.deploy_step_text4 = "异步发布任务已存在，请等候异步轮询服务后台处理";
            this.$emit('submit-success', true);
          }
        } else {
          this.deploy_step_status4 = "deploy_step_error";
          this.deploy_step_text4 = "派发异步发布任务失败：" + (publishRes.message || "未知错误");
          this.$emit('submit-success', false);
        }
      } catch (error) {
        console.error('发布失败:', error);
        this.$message.error('发布失败: ' + (error.message || '未知错误'));
        this.$emit('submit-success', false);
      } finally {
        this.deploying = false;
      }
    },
    
    resetSteps() {    
      this.deploy_step_text1 = '1. 验证主工作区文档数量';
      this.deploy_step_text2 = '2. 验证蓝环境';
      this.deploy_step_text3 = '3. 验证绿环境';
      this.deploy_step_text4 = '4. 派发异步发布任务';
      this.deploy_step_status1 = 'deploy_step';
      this.deploy_step_status2 = 'deploy_step';
      this.deploy_step_status3 = 'deploy_step';
      this.deploy_step_status4 = 'deploy_step';
    }
  }
}
</script>

<style scoped>
.deploy-steps-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 10px;
}

.deploy_step {
  display: block;
  font-family: 微软雅黑;
  font-weight: normal;
  font-size: small;
  color: #444;
  margin-top: 5px;
  width: 100%;
}

.deploy_step_active {
  color: orange;
  font-weight: 600;
}

.deploy_step_error {
  color: red;
  font-weight: 600;
}

.deploy_step_success {
  color: green;
  font-weight: 500;
}

.deploying-tip {
  margin-top: 16px;
  padding: 10px;
  background: #ecf5ff;
  border-radius: 4px;
  color: #409eff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.mb16 {
  margin-bottom: 16px;
}
</style>